var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"btn1",on:{"click":_vm.goClass}},[_vm._v("立即分享")])])
}
var staticRenderFns = []

export { render, staticRenderFns }